import styled from 'styled-components';

import { Modal } from '~/_legacy/components/atoms/modal';

import { Futura } from '~/styles';
import { media } from '~/utils';

import AboutFurusatoSpoImage from '@public/about-furusato/spo.svg';
import CloseIcon from '@public/images/close.svg';

type Props = {
  isModalOpen: boolean;
  onClick: () => void;
};

export function ModalSpo({ isModalOpen, onClick }: Props) {
  return (
    <Modal
      open={isModalOpen}
      backgroundColor='rgba(0, 0, 0, 0.5)'
      justifyContent='center'
      onClick={onClick}
    >
      <StyledWrapper>
        <StyledCloseButtonBox onClick={onClick}>
          <CloseIcon />
        </StyledCloseButtonBox>
        <StyledTitleBox>
          <StyledTitle1>
            <Futura>WHAT is SPO?</Futura>
          </StyledTitle1>
          <StyledTitle2>社会的に意義のある目的を持つ組織</StyledTitle2>
          <StyledTitle3>
            <span>S</span>ocial <span>P</span>urpose <span>O</span>rganization
          </StyledTitle3>
        </StyledTitleBox>
        <StyledContentsBox>
          <StyledContentsLeftBox>
            <StyledList>
              <StyledListItem>ボランティア団体</StyledListItem>
              <StyledListItem>非営利活動法人</StyledListItem>
              <StyledListItem>一般社団法人</StyledListItem>
              <StyledListItem>住民地縁団体</StyledListItem>
            </StyledList>
            <StyledParagraph>
              法人格に関係なく、社会的な価値を創造することを意図している組織のこと。多くの場合は、NPO法人、非営利型の一般社団法人や社会福祉法人ですが、ソーシャルベンチャーや法人格を有さない任意団体・学生団体も含め「社会的に意義のある目的を持つ」組織のことを意味します。
            </StyledParagraph>
          </StyledContentsLeftBox>
          <StyledContentsRightBox>
            <AboutFurusatoSpoImage />
          </StyledContentsRightBox>
        </StyledContentsBox>
      </StyledWrapper>
    </Modal>
  );
}

const StyledWrapper = styled.div`
  background-color: #ebebeb;
  border-radius: 16px;

  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 32px 20px;
  position: relative;
  width: 90vw;

  ${media.tbMin`
    gap: 32px;
    padding: 32px;
    width: 70vw;
  `}
`;

const StyledCloseButtonBox = styled.button`
  cursor: pointer;
  height: 28px;
  padding: 0;
  position: absolute;
  right: -14px;
  top: -14px;
  width: 28px;

  ${media.tbMin`
    height: 40px;
    right: -20px;
    top: -20px;
    width: 40px;
  `}

  svg {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;

const StyledTitleBox = styled.div`
  text-align: center;
  width: 100%;
`;

const StyledTitle1 = styled.h3`
  i {
    color: #ff346b;
    font-size: 14px;
    font-style: normal;
    line-height: 1;
  }

  ${media.tbMin`
    i {
      font-size: 16px;
    }
  `}
`;

const StyledTitle2 = styled.h3`
  color: #000000;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 4px;
  line-height: 1;
  margin-top: 8px;

  ${media.tbMin`
    font-size: 20px;
    margin-top: 12px;
  `}
`;

const StyledTitle3 = styled.h3`
  color: #acacac;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 1;
  margin-top: 8px;

  ${media.tbMin`
    font-size: 24px;
    margin-top: 12px;
  `}

  span {
    color: #ff346b;
  }
`;

const StyledContentsBox = styled.div`
  align-items: center;
  display: flex;
  flex-direction; column;
  width: 100%;
`;

const StyledContentsLeftBox = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 28px;
  justify-content: center;
  width: 100%;
`;

const StyledList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  list-style: none;
  width: 100%;
`;

const StyledListItem = styled.li`
  border: 2px solid #000;
  border-radius: 32px;
  font-size: 10px;
  font-weight: bold;
  line-height: 1;
  padding: 20px;
  text-align: center;
  width: 40%;

  ${media.tbMin`
    font-size: 12px;
  `}
`;

const StyledParagraph = styled.p`
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.6px;
  line-height: 2;
  width: 80%;

  ${media.tbMin`
    font-size: 16px;
  `}
`;

const StyledContentsRightBox = styled.div`
  aspect-ratio: 1 / 1;
  display: none;
  width: 100%;
  max-width: 498px;

  ${media.tbMin`
    display: block;
  `}

  svg {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;
